export function sellerAdvisoryResidentialDC924() {
return [   //2024 Release 2025-06-02 15:07:52
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 58.673,
 left: 53,
 width: 180,
 height: 27,
 }, 
{
   page: 0,
   name: "undefined", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 48.72,
   left: 270.6,
   width: 247.56,
   height: 9.153
}
,
{
   page: 0,
   name: "without right of transfer All rights reserved", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 744.36,
   left: 101.28,
   width: 209.28,
   height: 10.20
}
,
{
   page: 0,
   name: "Text4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 153.273,
   left: 179.037,
   width: 353.983,
   height: 15.419
}
,
{
   page: 0,
   name: "Text5", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 180.11,
   left: 179.037,
   width: 353.983,
   height: 15.418
}
,
{
   page: 0,
   name: "Text6", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 207.601,
   left: 179.037,
   width: 353.983,
   height: 15.418
}
,
{
   page: 0,
   name: "Text7", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 233.128,
   left: 179.037,
   width: 353.983,
   height: 15.418
}
,
{
   page: 1,
   name: "undefined_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 48.72,
   left: 270.6,
   width: 216.142,
   height: 9.153
}
,
{
   page: 1,
   name: "without right of transfer All rights reserved_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 744.36,
   left: 107.04,
   width: 203.52,
   height: 10.20
}
,
{
   page: 2,
   name: "undefined_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 48.72,
   left: 270.6,
   width: 220.854,
   height: 9.676
}
,
{
   page: 2,
   name: "without right of transfer All rights reserved_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 744.36,
   left: 105.993,
   width: 204.567,
   height: 10.20
}
,
{
   page: 3,
   name: "undefined_4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 48.72,
   left: 270.6,
   width: 219.284,
   height: 9.676
}
,
{
   page: 3,
   name: "without right of transfer All rights reserved_4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 744.36,
   left: 110.182,
   width: 200.378,
   height: 10.20
}
,
{
   page: 4,
   name: "undefined_5", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 47.52,
   left: 270.6,
   width: 223.996,
   height: 10.353
}
,
{
   page: 4,
   name: "signature Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 287.8,
   left: 72.0,
   width: 136.92,
   height: 15.56
}
,
{
   page: 4,
   name: "Date_3", 
   fontSize: 9,
   type: "date",
   top: 287.8,
   left: 216.36,
   width: 71.28,
   height: 15.56
}
,
{
   page: 4,
   name: "signature CoBroker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 287.8,
   left: 320.4,
   width: 136.92,
   height: 15.56
}
,
{
   page: 4,
   name: "Date_6", 
   fontSize: 9,
   type: "date",
   top: 287.8,
   left: 464.76,
   width: 71.28,
   height: 15.56
}
,
{
   page: 4,
   name: "without right of transfer All rights reserved_5", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 744.36,
   left: 135.84,
   width: 174.72,
   height: 10.20
}
] }
